export default __webpack_public_path__ + "static/media/main-swiper-3.d091aba4.png";